import React from 'react';
import { css } from 'glamor';
import map from 'lodash/map';
import { Watch } from 'scrollmonitor-react';

import { ribbon } from './styles';
import AnimationWrapper from '../AnimationWrapper';

class Ribbon extends React.Component {
  componentWillMount() {
    this.props.loadTheme();
  }

  render() {
    const colors = this.props.theme.ribbon;
    const { height, isInViewport } = this.props;

    return (
      <div {...ribbon} {...css({ height: height })}>
        {map(colors, (col, index) => {
          return (
            <div
              {...css({
                height: '100%',
                flex: '1 0 auto',
              })}
              key={`col-${index}`}
            >
              <AnimationWrapper
                inProp={isInViewport}
                transitionName="slideUp"
                delay={index * 15}
              >
                <span
                  {...css({
                    display: 'block',
                    height: height,
                    width: '100%',
                    backgroundColor: col,
                  })}
                />
              </AnimationWrapper>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Watch(Ribbon);



// WEBPACK FOOTER //
// ./src/components/Ribbon/Ribbon.js